var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProof(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 9.75H14.25V8.25H10.5V9.75ZM10.5 7.5H14.25V6H10.5V7.5ZM3.75 12H9.75V11.5875C9.75 11.025 9.475 10.5781 8.925 10.2469C8.375 9.91563 7.65 9.75 6.75 9.75C5.85 9.75 5.125 9.91563 4.575 10.2469C4.025 10.5781 3.75 11.025 3.75 11.5875V12ZM6.75 9C7.1625 9 7.51562 8.85313 7.80938 8.55938C8.10313 8.26562 8.25 7.9125 8.25 7.5C8.25 7.0875 8.10313 6.73438 7.80938 6.44063C7.51562 6.14688 7.1625 6 6.75 6C6.3375 6 5.98438 6.14688 5.69063 6.44063C5.39688 6.73438 5.25 7.0875 5.25 7.5C5.25 7.9125 5.39688 8.26562 5.69063 8.55938C5.98438 8.85313 6.3375 9 6.75 9ZM3 15C2.5875 15 2.23438 14.8531 1.94063 14.5594C1.64687 14.2656 1.5 13.9125 1.5 13.5V4.5C1.5 4.0875 1.64687 3.73438 1.94063 3.44063C2.23438 3.14687 2.5875 3 3 3H15C15.4125 3 15.7656 3.14687 16.0594 3.44063C16.3531 3.73438 16.5 4.0875 16.5 4.5V13.5C16.5 13.9125 16.3531 14.2656 16.0594 14.5594C15.7656 14.8531 15.4125 15 15 15H3ZM3 13.5H15V4.5H3V13.5Z",
    fill: "#626F86"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProof);
export default __webpack_public_path__ + "static/media/Proof.e2c78ebccfae3066cd5bbc7f934fa92e.svg";
export { ForwardRef as ReactComponent };